import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '../../../responsive';
import styles from '../../styles/grid.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Grid = _ref => {
  let {
    children
  } = _ref;
  const device = useDeviceType();
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['grid'], device === 'desktop' && styles['large']),
    children: children
  });
};
Grid.displayName = 'Grid';